import React, {
  useCallback,
} from 'react';
import {
  useNavigate,
  useLocation,
} from 'react-router-dom';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  DateTime,
} from 'luxon';
import i18n from 'i18next';

import {
  toast,
} from 'react-toastify';

import {
  coreActions,
  coreSelectors,
  ClientResourceType,
} from '@gymcloud/core';

import {
  getFeatures,
} from 'web-selectors';

import {
  Flex,
} from 'web-styled';

import {
  Select,
  ContentWrapper,
  PersonalEntityList,
} from 'web-components';

type Props = {
  resourceType: ClientResourceType,
};

const PersonalEntityPage = ({ resourceType }: Props) => {
  const location = useLocation();
  const mapState = useCallback(state => ({
    items: coreSelectors.getFolderItemsSortedByName(
      resourceType,
    )(state),
    profile: coreSelectors.getProfile(state),
    features: getFeatures(state),
    searchOptions: coreSelectors.getEntitySearchOptions(
      resourceType,
    )(state),
  }), [resourceType]);

  const {
    items,
    profile,
    features,
    searchOptions,
  } = useSelector(mapState, shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSave = () => {
    toast.info('Currently this feature is only available on mobile');
  };

  const handleEnterResults = (workout: any) => {
    const now = DateTime.local().toISO();
    const onSuccess = (ev) => {
      navigate(`/events/${ev.id}/results`);
    };
    dispatch(coreActions.requestCreateWorkoutEvents({
      isNow: true,
      userId: profile.id,
      payload: {
        begins_at: now,
        ends_at: now,
        personal_workout_id: workout.id,
      },
      callbacks: {
        onSuccess,
      },
    }));
  };

  return (
    <ContentWrapper
      header={(
        <Flex
          width="100%"
          height="68px"
          align="center"
        >
          <Select
            value=""
            isClearable
            options={searchOptions}
            styles={{
              container: provided => ({
                ...provided,
                width: '100%',
              }),
            }}
            placeholder={i18n.t(`Search $t(${resourceType})`)}
            onChange={(item) => {
              if (item?.value) {
                navigate(`${location.pathname}/${item.value}`);
              }
            }}
          />
        </Flex>
    )}
    >
      <PersonalEntityList
        items={profile.namespace === 'strongfirst'
          ? items.filter(item => item.is_purchased || item.is_purchased === null)
          : items}
        basePath={location.pathname}
        features={features}
        resourceType={resourceType}
        onSave={handleSave}
        onEnterResults={handleEnterResults}
      />
    </ContentWrapper>
  );
};

export default PersonalEntityPage;
